// components/HelpChatController.jsx
import React from 'react';
import { useSlotPortal } from '../hooks/useSlotPortal';
import { HelpChatPortalComponent } from './HelpChat';

export function HelpChatController({ isVisible = true }) {
  const menuElement = useSlotPortal('ai-chat', 'z-unified-nav-v2');

  if (!isVisible) {
    return null;
  }

  if (menuElement) {
    return <HelpChatPortalComponent menuElement={menuElement} />;
  }

  return null;
}
